//Anim countdown flexible
//array for each div Countdown
const tableCountDate = document.querySelectorAll('.bloc-countdown__date');

for (let i = 0; i < tableCountDate.length; i++) {
    //Get the date attribute for each div
    const attributeDate = tableCountDate[i].getAttribute('date-attribute');
    const replaceCountDownDate = attributeDate.replace(/\-/g, '/');
    const countDownDate = new Date(replaceCountDownDate).getTime();

    // Update the count down every 1 second
    const timeX = setInterval(function() {

        // Get today's date and time
        const now = new Date().getTime();

        // Find the distance between now and the count down date
        let distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);

        //If distance < 0 then reset for days, hours, minutes and seconds
        if (distance < 0) {
            tableCountDate[i].classList.add('bloc-countdown__date--past'); 
            days = 0;
            hours = 0;
            minutes = 0;
            seconds = 0;
        }

        //target each class (days,hours,minutes,seconds) for each div Coutdown
        let daysDiv = tableCountDate[i].querySelector('.bloc-countdown__date-day .bloc-countdown__date__number');
        let hoursDiv = tableCountDate[i].querySelector('.bloc-countdown__date-hours .bloc-countdown__date__number');
        let minutesDiv = tableCountDate[i].querySelector('.bloc-countdown__date-minutes .bloc-countdown__date__number');
        let secondsDiv = tableCountDate[i].querySelector('.bloc-countdown__date-seconds .bloc-countdown__date__number');

        //Add value in HTML 
        if (daysDiv !== null) {
            daysDiv.innerHTML = days;
        }
        if (hoursDiv !== null) {
            hoursDiv.innerHTML = hours;
        }
        if (minutesDiv !== null) {
            minutesDiv.innerHTML = minutes
        }
        if (secondsDiv !== null) {
            secondsDiv.innerHTML = seconds;
        }

    }, 1000);
} 